import { render, staticRenderFns } from "./AddFriendBtn.vue?vue&type=template&id=4600a4f5&scoped=true&"
import script from "./AddFriendBtn.vue?vue&type=script&lang=js&"
export * from "./AddFriendBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddFriendBtn.vue?vue&type=style&index=0&id=4600a4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600a4f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4600a4f5')) {
      api.createRecord('4600a4f5', component.options)
    } else {
      api.reload('4600a4f5', component.options)
    }
    module.hot.accept("./AddFriendBtn.vue?vue&type=template&id=4600a4f5&scoped=true&", function () {
      api.rerender('4600a4f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/buttons/AddFriendBtn.vue"
export default component.exports